import React from 'react';
import { Button, Form, Grid, Header, Image, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import logo from 'resources/logo.png';
import * as styles from './styles';
import { withRouter } from 'react-router-dom';
import Auth from 'stores/Auth';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import * as yup from 'yup';
import { observable, toJS } from 'mobx';
import qs from 'qs';

@withRouter
@inject(root => ({
	auth: root.auth
}))
@observer
export default class SetPassword extends React.Component {
	propTypes: {
		auth?: Auth
	};

	validationSchemaNewPassword = yup.object().shape({
		newPassword: yup
			.string()
			.label('Password')
			.min(5)
			.required(),
		newPasswordConfirm: yup.string().oneOf([yup.ref('newPassword')], "Passwords don't match")
	});

	@observable
	form = {
		newPassword: '',
		newPasswordConfirm: ''
	};

	msgStore = new MsgStore();

	setPassword = async () => {
		const { history } = this.props;
		const params = qs.parse(location.hash.substr(location.hash.indexOf('?') + 1));
		this.msgStore.clear();
		try {
			await this.validationSchemaNewPassword.validate(toJS(this.form));
			await Auth.setPassword(this.form.newPassword, params.access_token);
			this.msgStore.setInfo(
				<span>
					You password was updated. Please log in{' '}
					<a href="javascript:void(0)" onClick={() => history.push('/login')}>
						here
					</a>
					.
				</span>
			);
		} catch (err) {
			this.msgStore.setError(err);
		}
	};

	render() {
		let form = this.form;
		return (
			<div className={styles.setPasswordPage}>
				<Grid textAlign="center" style={{ height: '100%' }} verticalAlign="middle">
					<Grid.Column style={{ maxWidth: 450 }}>
						<Header as="h2" color="blue" textAlign="center">
							<Image src={logo} className={styles.logo} />
							<div>Set new password</div>
						</Header>
						<Form size="large">
							{!this.msgStore.info && (
								<Segment>
									<Form.Input
										fluid
										icon="lock"
										iconPosition="left"
										placeholder="New password"
										type="password"
										value={form.newPassword}
										onChange={e => (form.newPassword = e.target.value)}
									/>
									<Form.Input
										fluid
										icon="lock"
										iconPosition="left"
										placeholder="Re-type new password"
										type="password"
										value={form.newPasswordConfirm}
										onChange={e => (form.newPasswordConfirm = e.target.value)}
									/>

									<Button
										primary
										fluid
										size="large"
										onClick={() => {
											this.setPassword();
										}}
									>
										Submit
									</Button>
								</Segment>
							)}
							<MessageBox msgStore={this.msgStore} />
						</Form>
					</Grid.Column>
				</Grid>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/public/SetPassword/index.js